import { render, staticRenderFns } from "./Beasts.vue?vue&type=template&id=7f71d258&"
import script from "./Beasts.vue?vue&type=script&lang=js&"
export * from "./Beasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports